import { locales } from 'shared/locales'
import { localePath } from './locale-path'

/**
 * Pages that always render in light mode, whatever the visitor's theme: the landing is designed light (its dark
 * blocks set their own `dark` scope). Read by the root's first-paint theme script, the server render and the AppShell
 * theme effect; the visitor's saved preference is left untouched and applies again on every other page.
 */
export const LIGHT_ONLY_PATHS = ['/']

/**
 * The same pages as the BROWSER addresses them. The first-paint script runs before the router exists and reads
 * `location.pathname`, which still carries the locale segment the router's rewrite strips — so `/en` would miss
 * the list and the landing would flash dark for a dark-mode visitor.
 */
export const LIGHT_ONLY_PUBLIC_PATHS = [
  ...LIGHT_ONLY_PATHS,
  ...locales.flatMap((locale) => LIGHT_ONLY_PATHS.map((path) => localePath(path, locale))),
]

export function isLightOnlyPath(pathname: string) {
  return LIGHT_ONLY_PATHS.includes(pathname.replace(/\/+$/, '') || '/')
}
